module.exports = __webpack_public_path__ + "/bundle/asset/admission1-1-feece9e51956f3f32b5fcd58a3a03cdf.png";